import { useTranslations } from 'next-intl'
import { useMemo } from 'react'
import { renderHtmlTagMap } from '~/context/localisation'

/**
 * Parses HTML tags inside messages.
 * To be used in places where we expect tags to be present in the messages.
 * Please provide the full message key.
 */
export function useParseRichTextMessage(
  namespace: Parameters<typeof useTranslations>[0] | string = ''
) {
  const t = useTranslations(namespace as never)
  return useMemo(
    () => ({
      parser: (key: string, values?: Record<string, unknown>): string => {
        return t.rich(
          key as never,
          {
            ...renderHtmlTagMap,
            ...values,
          } as unknown as undefined
        ) as string
      },
    }),
    [t]
  )
}
